export default function ({ store, redirect, route, app }) {
  if (!store.getters['user/getActiveUser'].token) {
    // set_redirect_url page before giris yap
    const redirectPath = route?.fullPath || route?.path || '/'
    app.$cookies.set('redirectPath', redirectPath)
    redirect(app.localePath('/giris-yap'))
  }
}
